var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qz-service-pop"},[_c('div',{staticClass:"mask",on:{"click":_vm.close}}),_c('div',{staticClass:"body"},[_c('service-form',{ref:"formComp"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }